export default "__VITE_ASSET__5dhBGVNA__"